import {
    apiCguRecuperarPassword,
    apiColaboradorEliminarFoto,
    apiColaboradorGetFoto,
    apiColaboradorSaveCallCenterEspecialista,
    apiColaboradorSaveFoto,
    apiEspecialidadGetResgistros,
    apiGetColaboradoresCallCenterEspecialistas,
} from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";
import {
    fnHandleChangeChek,
    fnHandleChangeDate,
    fnHandleChangeText,
    fnHandleChangeTextUpper,
} from "../settings/handleConfig";
import { fnPrevent, fnPreventBlur } from "../settings/preventConfig";
import {
    getFormColaborador,
    getModelColaboradorCallCenter,
    getModelColaboradorEspecialista,
} from "../models/ColaboradorModel";
import { rxCorreo, rxUrl } from "../settings/regexConfig";

import { EnumTipoDoctor } from "../settings/enumConfig";
import { useCatalogo } from "./CatalogoContext";
import { useLayout } from "./LayoutContext";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";

export const ColaboradorContext = createContext();

export function ColaboradorProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { usuarioSesion } = useLogin();
    const { Get, Post, PostFile } = useRequest();
    const { entCatalogos } = useCatalogo();

    const [listaColaboradores, setListaColaboradores] = useState([]);
    const [listaEspecialidades, setListaEspecialidades] = useState([]);
    const [listaEspecialidadeslist, setListaEspecialidadesList] = useState([]);
    const [listaEspecialidadesCallCenter, setListaEspecialidadesCallCenter] = useState([]);
    const [colaboradorSeleccionado, setColaboradorSeleccionado] = useState(getModelColaboradorCallCenter());
    const [modalOpenFormColaborador, setModalOpenFormColaborador] = useState(false);
    const [modalOpenDetalleColaborador, setModalOpenDetalleColaborador] = useState(false);
    const [modalOpenEliminarColaborador, setModalOpenEliminarColaborador] = useState(false);
    const [modalOpenFotoColaborador, setModalOpenFotoColaborador] = useState(false);
    const [modalOpenReenviarCredenciales, setModalOpenReenviarCredenciales] = useState(false);
    const [modalOpenEliminarFotoColaborador, setModalOpenEliminarFotoColaborador] = useState(false);
    const [formColaborador, setFormColaborador] = useState(getFormColaborador());
    const [formTabIndex, setFormTabIndex] = useState(0);
    const [fotoColaborador, setFotoColaborador] = useState("");
    const [mostrarPassword, setMostrarPassword] = useState(false);

    const handleChangeColaboradorSeleccionado = (value) => {
        setColaboradorSeleccionado(value);
    };

    const handleOpenFormColaborador = (value) => {
        setModalOpenFormColaborador(value);
    };

    const handleOpenDetalleColaborador = (value) => {
        setModalOpenDetalleColaborador(value);
    };

    const handleOpenEliminarColaborador = (value) => {
        setModalOpenEliminarColaborador(value);
    };

    const handleOpenFotoColaborador = (value) => {
        setModalOpenFotoColaborador(value);
    };

    const handleOpenReenviarCredenciales = (value) => {
        setModalOpenReenviarCredenciales(value);
    };

    const handleOpenEliminarFotoColaborador = (value) => {
        setModalOpenEliminarFotoColaborador(value);
    };

    const handleChangeFormColaboradorText = fnHandleChangeText(formColaborador, setFormColaborador);
    const handleChangeFormColaboradorTextUpper = fnHandleChangeTextUpper(formColaborador, setFormColaborador);
    const handleChangeFormColaboradorDate = fnHandleChangeDate(formColaborador, setFormColaborador);
    const handleChangeFormColaboradorCheck = fnHandleChangeChek(formColaborador, setFormColaborador);

    const handleChangeMostrarPassword = (value) => {
        setMostrarPassword(value);
    };

    const handleChangeInternoExterno = (e) => {
        const { rdEspecialidad } = getFormColaborador();
        const value = e.target.value;
        setFormColaborador({
            ...formColaborador,
            rdEspecialidad: {
                ...rdEspecialidad,
                value: value,
            },
        });
        // console.log(value);
        if (value == "1") {
            setListaEspecialidades(listaEspecialidadesCallCenter);
        } else {
            setListaEspecialidades(listaEspecialidadeslist);
        }
    };

    const handleChangeTabIndex = (value) => {
        setFormTabIndex(value);
    };

    const handleClickNuevoColaboradorCallCenter = () => {
        const colaborador = getModelColaboradorCallCenter();
        setColaboradorSeleccionado(colaborador);
        fnFillFormulario(colaborador);
        setFormTabIndex(0);
        setModalOpenFormColaborador(true);
    };

    const handleClickNuevoColaboradorEspecialista = () => {
        const colaborador = getModelColaboradorEspecialista();
        setColaboradorSeleccionado(colaborador);
        fnFillFormulario(colaborador);
        setFormTabIndex(0);
        setModalOpenFormColaborador(true);
    };

    const handleClickEditarColaborador = () => {
        if (colaboradorSeleccionado.iIdColaborador === 0) {
            handleOpenAlert("Seleccione un colaborador para editar");
            return;
        }
        fnFillFormulario(colaboradorSeleccionado);
        setFormTabIndex(0);
        setModalOpenFormColaborador(true);
    };

    const handleClickDetalleColaborador = () => {
        if (colaboradorSeleccionado.iIdColaborador === 0) {
            handleOpenAlert("Seleccione un colaborador para ver el detalle");
            return;
        }
        setModalOpenDetalleColaborador(true);
    };

    const handleClickFotoColaborador = async () => {
        if (colaboradorSeleccionado.iIdColaborador === 0) {
            handleOpenAlert("Seleccione un colaborador para ver la foto");
            return;
        }
        await fnObtenerFotoColaborador(colaboradorSeleccionado.iIdColaborador);
        setModalOpenFotoColaborador(true);
    };

    const handleClickReenviarCredenciales = () => {
        if (colaboradorSeleccionado.iIdColaborador === 0) {
            handleOpenAlert("Seleccione un colaborador para reenviar las credenciales");
            return;
        }
        setModalOpenReenviarCredenciales(true);
    };

    const handleClickEliminarColaborador = () => {
        if (colaboradorSeleccionado.iIdColaborador === 0) {
            handleOpenAlert("Seleccione un colaborador para eliminar");
            return;
        }
        setModalOpenEliminarColaborador(true);
    };

    const handleClickRefrescarDatos = async () => {
        await fnObtenerEspecialidades();
        await fnObtenerColaboradores();
    };

    const handleClickCambiarFoto = () => {
        let input = document.createElement("input");
        input.type = "file";
        input.value = "";
        input.addEventListener("change", () => {
            let archivo = input.files[0];
            if (!archivo) {
                handleOpenAlert("No se cargó ningún archivo");
                return;
            }

            if (archivo.type !== "image/jpeg" && archivo.type !== "image/png") {
                handleOpenAlert("El formato de la imagen debe ser .jpg o .png");
                return;
            }

            if (parseInt(archivo.size) > 2097152) {
                handleOpenAlert("El tamaño de la imagen no debe exceder los 2MB");
                return;
            }

            let img = new Image();
            img.onload = function () {
                const imgW = this.width.toFixed(0);
                const imgH = this.height.toFixed(0);

                //proporcion ideal = 9 / 16
                const proporcionMAX = 9 / 17;
                const proporcionMIN = 9 / 12;
                const proporcionImg = imgW / imgH;

                if (proporcionImg < proporcionMAX || proporcionImg > proporcionMIN) {
                    handleOpenAlert(
                        "Las proporciones de la imagen deben ser entre 9:12 (ancho:altura) y 9:16 (ancho:altura). Ejemplo: 600px x 900px (ancho x altura)."
                    );
                    return;
                }
                fnGuardarFotoColaborador(colaboradorSeleccionado.iIdColaborador, usuarioSesion.iIdUsuario, archivo);
            };

            img.src = URL.createObjectURL(archivo);
        });

        input.click();
        input.remove();
    };

    const handleClickEliminarFoto = () => {
        setModalOpenEliminarFotoColaborador(true);
    };

    const handleSubmitFormColaborador = (e) => {
        fnPrevent(e);

        const {
            txtNombreDirectorio,
            txtCedulaDirectorio,
            txtRFCDirectorio,
            txtTelefonoDirectorio,
            txtWhatsAppDirectorio,
            txtEmailDirectorio,
            slcEspecialidad,
            txtNombreConsultorio,
            txtDireccionConsultorio,
            txtUrlDirectorio,
            txtMapsDirectorio,
            txtNombreDoctor,
            txtApellidoPaternoDoctor,
            txtApellidoMaternoDoctor,
            dtpFechaNacimientoDoctor,
            txtTelefonoDoctor,
            txtEmailDoctor,
            txtDomicilioDoctor,
            txtUsuarioTitular,
            txtPasswordTitular,
            txtUsuarioAdmin,
            txtPasswordAdmin,
            chkAccesoDoctor,
            chkDoctorAdm,
        } = formColaborador;

        const telDirectorio = txtTelefonoDirectorio.value.replace(/ /g, "");
        const telDoctor = txtTelefonoDoctor.value.replace(/ /g, "");
        const telWhatsApp = txtWhatsAppDirectorio.value.replace(/ /g, "");
        const especialidad = parseInt(slcEspecialidad.value);
        //const cedula = parseInt(txtCedulaDirectorio.value);

        const formValidacionGrupo1 = {
            txtNombreDirectorio: {
                ...txtNombreDirectorio,
                error: txtNombreDirectorio.value === "",
            },
            txtCedulaDirectorio: {
                ...txtCedulaDirectorio,
                error: txtCedulaDirectorio.value === "" || txtCedulaDirectorio.value.length !== 8,
            },
            txtRFCDirectorio: {
                ...txtRFCDirectorio,
                error: txtRFCDirectorio.value === "" || txtRFCDirectorio.value.length !== 13,
            },
            txtTelefonoDirectorio: {
                ...txtTelefonoDirectorio,
                error: telDirectorio.length !== 10,
            },
            txtWhatsAppDirectorio: {
                ...txtWhatsAppDirectorio,
                error: txtWhatsAppDirectorio.value !== "" && telWhatsApp.length !== 10,
            },
            txtEmailDirectorio: {
                ...txtEmailDirectorio,
                error: !rxCorreo.test(txtEmailDirectorio.value),
            },
            slcEspecialidad: {
                ...slcEspecialidad,
                error: isNaN(especialidad),
            },
            txtUrlDirectorio: {
                ...txtUrlDirectorio,
                error: txtUrlDirectorio.value !== "" && !rxUrl.test(txtUrlDirectorio.value),
            },
            txtMapsDirectorio: {
                ...txtMapsDirectorio,
                error: txtMapsDirectorio.value !== "" && !rxUrl.test(txtMapsDirectorio.value),
            },
        };

        const formValidacionGrupo2 = {
            txtNombreDoctor: {
                ...txtNombreDoctor,
                error: txtNombreDoctor.value === "",
            },
            txtApellidoPaternoDoctor: {
                ...txtApellidoPaternoDoctor,
                error: txtApellidoPaternoDoctor.value === "",
            },
            // txtApellidoMaternoDoctor: {
            //   ...txtApellidoMaternoDoctor,
            //   error: txtApellidoMaternoDoctor.value === "",
            // },
            dtpFechaNacimientoDoctor: {
                ...dtpFechaNacimientoDoctor,
                error: !dtpFechaNacimientoDoctor.value,
            },
            txtTelefonoDoctor: {
                ...txtTelefonoDoctor,
                error: telDoctor.length !== 10,
            },
            txtEmailDoctor: {
                ...txtEmailDoctor,
                error: !rxCorreo.test(txtEmailDoctor.value),
            },
        };

        const formValidacionGrupo3 = {
            txtUsuarioTitular: {
                ...txtUsuarioTitular,
                error: chkAccesoDoctor.value && txtUsuarioTitular.value === "",
            },
            txtPasswordTitular: {
                ...txtPasswordTitular,
                error:
                    chkAccesoDoctor.value &&
                    colaboradorSeleccionado.iIdColaborador === 0 &&
                    (txtPasswordTitular.value === "" || txtUsuarioTitular.value === ""),
            },
            txtUsuarioAdmin: {
                ...txtUsuarioAdmin,
                error:
                    chkAccesoDoctor.value &&
                    colaboradorSeleccionado.iIdTipoDoctor === EnumTipoDoctor.Especialista &&
                    txtUsuarioAdmin.value === "",
            },
            txtPasswordAdmin: {
                ...txtPasswordAdmin,
                error:
                    chkAccesoDoctor.value &&
                    colaboradorSeleccionado.iIdTipoDoctor === EnumTipoDoctor.Especialista &&
                    colaboradorSeleccionado.iIdColaborador === 0 &&
                    (txtPasswordAdmin.value === "" || txtUsuarioAdmin.value === ""),
            },
        };

        const formValidacion = {
            ...formColaborador,
            ...formValidacionGrupo1,
            ...formValidacionGrupo2,
            ...formValidacionGrupo3,
        };

        setFormColaborador(formValidacion);

        if (
            Object.values(formValidacionGrupo3)
                .map((x) => x.error)
                .includes(true)
        ) {
            setFormTabIndex(2);
        }
        if (
            Object.values(formValidacionGrupo2)
                .map((x) => x.error)
                .includes(true)
        ) {
            setFormTabIndex(1);
        }
        if (
            Object.values(formValidacionGrupo1)
                .map((x) => x.error)
                .includes(true)
        ) {
            setFormTabIndex(0);
        }

        if (
            Object.values(formValidacion)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        const entColaborador = {
            iIdColaborador: colaboradorSeleccionado.iIdColaborador,
            iIdTipoDoctor: colaboradorSeleccionado.iIdTipoDoctor,
            iIdEspecialidad: parseInt(slcEspecialidad.value),
            iIdUsuarioCGU: colaboradorSeleccionado.iIdColaborador === 0 ? 0 : colaboradorSeleccionado.iIdUsuarioCGU,
            sNombreDirectorio: txtNombreDirectorio.value,
            sCedulaProfecional: txtCedulaDirectorio.value,
            sWhatsApp: txtWhatsAppDirectorio.value,
            sTelefonoDirectorio: txtTelefonoDirectorio.value,
            sCorreoDirectorio: txtEmailDirectorio.value,
            sNombreConsultorio: txtNombreConsultorio.value,
            sDireccionConsultorio: txtDireccionConsultorio.value,
            sRFC: txtRFCDirectorio.value,
            sURL: txtUrlDirectorio.value,
            sMaps: txtMapsDirectorio.value,
            sUsuarioTitular: txtUsuarioTitular.value === "" ? null : txtUsuarioTitular.value,
            sPasswordTitular: txtPasswordTitular.value === "" ? null : txtPasswordTitular.value,
            sUsuarioAdministrativo:
                colaboradorSeleccionado.iIdTipoDoctor === EnumTipoDoctor.Especialista
                    ? txtUsuarioAdmin.value === ""
                        ? null
                        : txtUsuarioAdmin.value
                    : null,
            sPasswordAdministrativo:
                colaboradorSeleccionado.iIdTipoDoctor === EnumTipoDoctor.Especialista
                    ? txtPasswordAdmin.value === ""
                        ? null
                        : txtPasswordAdmin.value
                    : null,
            sNombresDoctor: txtNombreDoctor.value,
            sApellidoPaternoDoctor: txtApellidoPaternoDoctor.value,
            sApellidoMaternoDoctor: txtApellidoMaternoDoctor.value,
            dtFechaNacimientoDoctor: dtpFechaNacimientoDoctor.value.toLocaleDateString(),
            sTelefonoDoctor: txtTelefonoDoctor.value,
            sCorreoDoctor: txtEmailDoctor.value,
            sDomicilioDoctor: txtDomicilioDoctor.value,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            bAcceso: chkAccesoDoctor.value,
            bAdministrador: chkDoctorAdm.value,
            bActivo: true,
            bBaja: false,
        };

        fnGuardarColaborador(entColaborador);
    };

    const handleSubmitEliminarColaborador = () => {
        const entColaborador = {
            iIdColaborador: colaboradorSeleccionado.iIdColaborador,
            iIdTipoDoctor: colaboradorSeleccionado.iIdTipoDoctor,
            iIdUsuarioCGU: colaboradorSeleccionado.iIdUsuarioCGU,
            iIdUsuarioMod: usuarioSesion.iIdUsuario,
            bActivo: false,
            bBaja: true,
        };

        fnEliminarColaborador(entColaborador);
    };

    const handleSubmitEliminarFoto = () => {
        fnEliminarFotoColaborador(colaboradorSeleccionado.iIdColaborador);
    };

    const handleSubmitReenviarCredenciales = () => {
        const entReenviar = {
            sCorreo: colaboradorSeleccionado.sCorreoDoctor,
        };

        fnReenviarCredenciales(entReenviar);
    };

    const fnFillFormulario = (colaborador) => {
        const {
            txtNombreDirectorio,
            txtCedulaDirectorio,
            txtRFCDirectorio,
            txtTelefonoDirectorio,
            txtWhatsAppDirectorio,
            txtEmailDirectorio,
            slcEspecialidad,
            txtNumeroSala,
            txtNombreConsultorio,
            txtDireccionConsultorio,
            txtUrlDirectorio,
            txtMapsDirectorio,
            txtNombreDoctor,
            txtApellidoPaternoDoctor,
            txtApellidoMaternoDoctor,
            dtpFechaNacimientoDoctor,
            txtTelefonoDoctor,
            txtEmailDoctor,
            txtDomicilioDoctor,
            txtUsuarioTitular,
            txtPasswordTitular,
            txtUsuarioAdmin,
            txtPasswordAdmin,
            chkAccesoDoctor,
            chkDoctorAdm,
            rdEspecialidad,
        } = getFormColaborador();

        setFormColaborador({
            ...formColaborador,
            txtNombreDirectorio: {
                ...txtNombreDirectorio,
                value: !colaborador.sNombreDirectorio ? "" : colaborador.sNombreDirectorio,
            },
            txtCedulaDirectorio: {
                ...txtCedulaDirectorio,
                value: !colaborador.sCedulaProfecional ? "" : colaborador.sCedulaProfecional,
            },
            txtRFCDirectorio: {
                ...txtRFCDirectorio,
                value: !colaborador.sRFC ? "" : colaborador.sRFC,
            },
            txtTelefonoDirectorio: {
                ...txtTelefonoDirectorio,
                value: !colaborador.sTelefonoDirectorio ? "" : colaborador.sTelefonoDirectorio,
            },
            txtWhatsAppDirectorio: {
                ...txtWhatsAppDirectorio,
                value: !colaborador.sWhatsApp ? "" : colaborador.sWhatsApp,
            },
            txtEmailDirectorio: {
                ...txtEmailDirectorio,
                value: !colaborador.sCorreoDirectorio ? "" : colaborador.sCorreoDirectorio,
            },
            slcEspecialidad: {
                ...slcEspecialidad,
                value: !colaborador.iIdEspecialidad ? "" : colaborador.iIdEspecialidad,
            },
            txtNumeroSala: {
                ...txtNumeroSala,
                value: !colaborador.iNumSala ? "" : colaborador.iNumSala,
            },
            txtNombreConsultorio: {
                ...txtNombreConsultorio,
                value: !colaborador.sNombreConsultorio ? "" : colaborador.sNombreConsultorio,
            },
            txtDireccionConsultorio: {
                ...txtDireccionConsultorio,
                value: !colaborador.sDireccionConsultorio ? "" : colaborador.sDireccionConsultorio,
            },
            txtUrlDirectorio: {
                ...txtUrlDirectorio,
                value: !colaborador.sURL ? "" : colaborador.sURL,
            },
            txtMapsDirectorio: {
                ...txtMapsDirectorio,
                value: !colaborador.sMaps ? "" : colaborador.sMaps,
            },
            txtNombreDoctor: {
                ...txtNombreDoctor,
                value: !colaborador.sNombresDoctor ? "" : colaborador.sNombresDoctor,
            },
            txtApellidoPaternoDoctor: {
                ...txtApellidoPaternoDoctor,
                value: !colaborador.sApellidoPaternoDoctor ? "" : colaborador.sApellidoPaternoDoctor,
            },
            txtApellidoMaternoDoctor: {
                ...txtApellidoMaternoDoctor,
                value: !colaborador.sApellidoMaternoDoctor ? "" : colaborador.sApellidoMaternoDoctor,
            },
            dtpFechaNacimientoDoctor: {
                ...dtpFechaNacimientoDoctor,
                value: !colaborador.dtFechaNacimientoDoctor ? null : new Date(colaborador.dtFechaNacimientoDoctor),
            },
            txtTelefonoDoctor: {
                ...txtTelefonoDoctor,
                value: !colaborador.sTelefonoDoctor ? "" : colaborador.sTelefonoDoctor,
            },
            txtEmailDoctor: {
                ...txtEmailDoctor,
                value: !colaborador.sCorreoDoctor ? "" : colaborador.sCorreoDoctor,
            },
            txtDomicilioDoctor: {
                ...txtDomicilioDoctor,
                value: !colaborador.sDomicilioDoctor ? "" : colaborador.sDomicilioDoctor,
            },
            txtUsuarioTitular: {
                ...txtUsuarioTitular,
                value: !colaborador.sUsuarioTitular ? "" : colaborador.sUsuarioTitular,
            },
            txtPasswordTitular: { ...txtPasswordTitular, value: "" },
            txtUsuarioAdmin: {
                ...txtUsuarioAdmin,
                value: !colaborador.sUsuarioAdministrativo ? "" : colaborador.sUsuarioAdministrativo,
            },
            txtPasswordAdmin: { ...txtPasswordAdmin, value: "" },
            chkAccesoDoctor: {
                ...chkAccesoDoctor,
                value: !colaborador.bAcceso ? false : colaborador.bAcceso,
            },
            chkDoctorAdm: {
                ...chkDoctorAdm,
                value: !colaborador.bAdministrador ? false : colaborador.bAdministrador,
            },
            rdEspecialidad: {
                ...rdEspecialidad,
                value: !colaborador.bInterno ? "2" : "1",
            },
        });
        if (colaborador.bInterno) {
            setListaEspecialidades(listaEspecialidadesCallCenter);
        } else {
            setListaEspecialidades(listaEspecialidadeslist);
        }
    };

    const fnObtenerEspecialidades = async (piIdEspecialidad = null) => {
        const payload = {
            loader: "Consultando especialidades...",
            url: apiEspecialidadGetResgistros + "?piIdEspecialidad=" + piIdEspecialidad,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaEspecialidades(response.Result.filter((x) => !x.bInterno));
            setListaEspecialidadesList(response.Result.filter((x) => !x.bInterno));
            setListaEspecialidadesCallCenter(response.Result.filter((x) => x.bInterno));
        }
    };

    const fnObtenerColaboradores = async (
        piIdColaborador = null,
        piIdTipoDoctor = null,
        piIdEspecialidad = null,
        piIdUsuarioCGU = null
    ) => {
        const payload = {
            loader: "Consultando colaboradores...",
            url:
                apiGetColaboradoresCallCenterEspecialistas +
                "?piIdColaborador=" +
                piIdColaborador +
                "&piIdTipoDoctor=" +
                piIdTipoDoctor +
                "&piIdEspecialidad=" +
                piIdEspecialidad +
                "&piIdUsuarioCGU=" +
                piIdUsuarioCGU,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setListaColaboradores(response.Result);
        }
    };

    const fnGuardarColaborador = async (entColaborador) => {
        const payload = {
            loader: "Guardando colaborador...",
            url: apiColaboradorSaveCallCenterEspecialista,
            body: entColaborador,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenFormColaborador(false);
            setColaboradorSeleccionado(entColaborador);
            await fnObtenerColaboradores();
        }
        fnPreventBlur();
    };

    const fnObtenerFotoColaborador = async (piIdColaborador) => {
        const payload = {
            loader: "Consultando foto del colaborador...",
            url: apiColaboradorGetFoto + "?piIdColaborador=" + piIdColaborador,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setFotoColaborador(response.Result);
        } else {
            setFotoColaborador("");
        }
    };

    const fnGuardarFotoColaborador = async (piIdColaborador, piIdUsuarioMod, foto) => {
        const payload = {
            loader: "Guardando foto del colaborador...",
            url: apiColaboradorSaveFoto + "?piIdColaborador=" + piIdColaborador + "&piIdUsuarioMod=" + piIdUsuarioMod,
            file: foto,
            alert: true,
        };

        const response = await PostFile(payload);
        if (response.Code === 0) {
            await fnObtenerFotoColaborador(colaboradorSeleccionado.iIdColaborador);
        }
    };

    const fnEliminarFotoColaborador = async (piIdColaborador) => {
        const payload = {
            loader: "Eliminando foto de colaborador...",
            url:
                apiColaboradorEliminarFoto +
                "?piIdColaborador=" +
                piIdColaborador +
                "&piIdUsuarioMod=" +
                usuarioSesion.iIdUsuario,
            body: {},
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setFotoColaborador("");
            setModalOpenEliminarFotoColaborador(false);
        }
    };

    const fnReenviarCredenciales = async (entUsuario) => {
        const payload = {
            loader: "Reenviando credenciales...",
            url: apiCguRecuperarPassword,
            body: entUsuario,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenReenviarCredenciales(false);
        }
    };

    const fnEliminarColaborador = async (entColaborador) => {
        const payload = {
            loader: "Eliminando colaborador...",
            url: apiColaboradorSaveCallCenterEspecialista,
            body: entColaborador,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setModalOpenEliminarColaborador(false);
            setColaboradorSeleccionado(getModelColaboradorCallCenter());
            await fnObtenerColaboradores();
        }
    };

    return (
        <ColaboradorContext.Provider
            value={{
                listaColaboradores,
                listaEspecialidadesCallCenter,
                listaEspecialidades,
                colaboradorSeleccionado,
                modalOpenFormColaborador,
                modalOpenDetalleColaborador,
                modalOpenEliminarColaborador,
                modalOpenFotoColaborador,
                modalOpenReenviarCredenciales,
                modalOpenEliminarFotoColaborador,
                formColaborador,
                formTabIndex,
                fotoColaborador,
                mostrarPassword,
                handleOpenFormColaborador,
                handleOpenDetalleColaborador,
                handleOpenEliminarColaborador,
                handleOpenFotoColaborador,
                handleOpenReenviarCredenciales,
                handleOpenEliminarFotoColaborador,
                handleChangeColaboradorSeleccionado,
                handleChangeFormColaboradorText,
                handleChangeFormColaboradorTextUpper,
                handleChangeFormColaboradorDate,
                handleChangeFormColaboradorCheck,
                handleChangeMostrarPassword,
                handleChangeInternoExterno,
                handleChangeTabIndex,
                handleClickNuevoColaboradorCallCenter,
                handleClickNuevoColaboradorEspecialista,
                handleClickEditarColaborador,
                handleClickDetalleColaborador,
                handleClickFotoColaborador,
                handleClickReenviarCredenciales,
                handleClickEliminarColaborador,
                handleClickRefrescarDatos,
                handleClickCambiarFoto,
                handleClickEliminarFoto,
                handleSubmitFormColaborador,
                handleSubmitEliminarColaborador,
                handleSubmitEliminarFoto,
                handleSubmitReenviarCredenciales,
            }}
        >
            {props.children}
        </ColaboradorContext.Provider>
    );
}

export function useColaborador() {
    return useContext(ColaboradorContext);
}
